import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Unauthorized.css';

const Unauthorized = () => {
    const navigate = useNavigate();
    const { user, logout } = useAuth();

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="unauthorized-container">
            <div className="unauthorized-card">
                <div className="unauthorized-icon">🚫</div>
                <h1>Access Denied</h1>
                <p className="unauthorized-message">
                    You do not have permission to access this resource.
                </p>
                {user && (
                    <p className="unauthorized-role">
                        Your current role: <strong>{user.role}</strong>
                    </p>
                )}
                <div className="unauthorized-actions">
                    <button onClick={handleGoBack} className="btn btn-secondary">
                        Go Back
                    </button>
                    <button onClick={handleLogout} className="btn btn-primary">
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
